import { AsyncOptions, AsyncState, Option, Widget, any, async, none, some, unloadedAsyncState } from 'widgets-for-react'

export type AsyncMonitor<a> = {
  Add: (next_promise: AsyncState<a>) => AsyncMonitor<a>
  Widget: Widget<AsyncMonitor<a>>
  Result: AsyncState<a>
}

type AsyncMonitorState<a> = {
  readonly next_async: Option<AsyncState<a>>
  readonly current_async1: AsyncState<a>
  readonly current_async2: AsyncState<a>
  readonly frame_counter: number
}

export let async_queue =
  <a>(options?: AsyncOptions<a>) =>
  (_async?: AsyncState<a>): AsyncMonitor<a> => {
    let update_async_queue = (s0: AsyncMonitorState<a>): AsyncMonitor<a> => {
      let widget = any<AsyncMonitor<a>>([
        async(s0.current_async1, undefined, options ? { ...options, key: options.key + '_1' } : undefined).map<
          AsyncMonitor<a>
        >((a) => {
          let current_async1 = a(s0.current_async1)
          let s1 = { ...s0, current_async1 }
          if (current_async1.kind == 'loaded') {
            if (s0.next_async.kind == 'r') {
              let next_async = s0.next_async.v
              s1 = {
                next_async: none<AsyncState<a>>(),
                current_async1: unloadedAsyncState(),
                current_async2: next_async,
                frame_counter: s0.frame_counter + 1
              }
            }
          }
          return update_async_queue(s1)
        }),
        async(s0.current_async2, undefined, options ? { ...options, key: options.key + '_2' } : undefined).map<
          AsyncMonitor<a>
        >((a) => {
          let current_async2 = a(s0.current_async2)
          let s1 = { ...s0, current_async2 }
          if (current_async2.kind == 'loaded') {
            if (s0.next_async.kind == 'r') {
              let next_async = s0.next_async.v
              s1 = {
                next_async: none<AsyncState<a>>(),
                current_async1: next_async,
                current_async2: unloadedAsyncState(),
                frame_counter: s0.frame_counter + 1
              }
            }
          }
          return update_async_queue(s1)
        })
      ])
      return {
        Add: (next_promise: AsyncState<a>) => {
          let s1 = { ...s0, next_async: some(next_promise) }

          if (s0.current_async1.kind == 'unloaded' && s0.current_async2.kind == 'unloaded') {
            s1 = { ...s0, next_async: none(), current_async1: next_promise, frame_counter: 0 }
          } else {
            if (
              s0.frame_counter % 2 == 0 &&
              (s0.current_async1.kind == 'loaded' || s0.current_async1.kind == 'unloaded')
            ) {
              s1 = {
                next_async: none(),
                current_async2: next_promise,
                current_async1: unloadedAsyncState(),
                frame_counter: s0.frame_counter + 1
              }
            } else {
              if (
                s0.frame_counter % 2 != 0 &&
                (s0.current_async2.kind == 'loaded' || s0.current_async2.kind == 'unloaded')
              ) {
                console.log('C', s0, next_promise.kind)
                s1 = {
                  next_async: none(),
                  current_async1: next_promise,
                  current_async2: unloadedAsyncState(),
                  frame_counter: s0.frame_counter + 1
                }
              }
            }
          }

          return update_async_queue(s1)
        },
        Result: s0.frame_counter % 2 == 0 ? s0.current_async1 : s0.current_async2,
        Widget: widget
      }
    }
    let state: AsyncMonitorState<a> = {
      next_async: none(),
      current_async1: _async ? _async : unloadedAsyncState(),
      current_async2: unloadedAsyncState(),
      frame_counter: 0
    }
    return update_async_queue(state)
  }
